
import { CameraInventory, CameraFormValues } from "@/types/inventory";
import { UseFormReturn } from "react-hook-form";
import { AddCameraForm } from "@/components/inventory/AddCameraForm";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useTranslation } from "@/hooks/useTranslation";

interface EditCameraDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  camera: CameraInventory;
  form: UseFormReturn<CameraFormValues>;
  onSubmit: (values: CameraFormValues) => Promise<void>;
}

export function EditCameraDialog({
  isOpen,
  setIsOpen,
  camera,
  form,
  onSubmit
}: EditCameraDialogProps) {
  const { t } = useTranslation();
  
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-md sm:max-w-md md:max-w-md w-[95%] p-4 pt-5">
        <DialogHeader className="mb-1">
          <DialogTitle>{t('edit_camera')}</DialogTitle>
          <DialogDescription>
            {t('update_camera_details')} {camera?.brand} {camera?.model}
          </DialogDescription>
        </DialogHeader>
        <AddCameraForm form={form} onSubmit={onSubmit} isEditing={true} />
      </DialogContent>
    </Dialog>
  );
}
